module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-markdown-4fa460106c86760fefcb60807eb3161e.svg";